import {
  Body,
  Button,
  H3,
  Stack,
  useWindowProperties,
} from '@qred/components-library';
import React from 'react';
import styled from 'styled-components';

type ConfirmationCardProps = {
  header: string;
  text: string;
  headerImgSrc?: string;
} & (
  | { buttonText: string; onButtonClick: () => void }
  | { buttonText?: never; onButtonClick?: never }
);
export const ConfirmationCard = (props: ConfirmationCardProps) => {
  const { header, text, buttonText, onButtonClick, headerImgSrc } = props;
  const { isMobile } = useWindowProperties();

  return (
    <Stack
      p={isMobile ? '16px' : '0'}
      maw={isMobile ? 'initial' : '571px'}
      align="center"
    >
      <Stack spacing={0}>
        {headerImgSrc && <HeaderImg src={headerImgSrc} $isMobile={isMobile} />}
        <H3 color="Text/Headlines_(Brand)">{header}</H3>
      </Stack>
      <Body size={isMobile ? 'lg' : 'xl'} color="Text/Default" mt={'78px'}>
        {text}
      </Body>
      {buttonText !== undefined && onButtonClick !== undefined && (
        <Button
          mt={isMobile ? 'auto' : '74px'}
          fullWidth={isMobile}
          size="md"
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      )}
    </Stack>
  );
};

const HeaderImg = styled.img<{ $isMobile: boolean }>`
  width: ${(props) => (props.$isMobile ? '300px' : '460px')};
  margin-bottom: ${(props) => (props.$isMobile ? '-83px' : '-125px')};
`;
